module.exports = __webpack_public_path__ + "static/media/1_pl.97f18ab7.png";